import { render, staticRenderFns } from "./userAdminTable.vue?vue&type=template&id=304fb276&"
import script from "./userAdminTable.vue?vue&type=script&lang=js&"
export * from "./userAdminTable.vue?vue&type=script&lang=js&"
import style0 from "./userAdminTable.vue?vue&type=style&index=0&id=304fb276&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports